import { CONTRACT_SECTIONS } from "./variables.config";

interface VariablesViewProps {
  variables: Record<string, string>;
}

export const VariablesView = ({ variables }: VariablesViewProps) => {
  // Get all variables from contract sections
  const sectionVariables = new Set<string>();
  CONTRACT_SECTIONS.forEach(section => {
    section.templateParts
      .filter(part => typeof part === 'object' && 'var' in part)
      .forEach(part => sectionVariables.add((part as { var: string }).var));
  });

  // Get custom variables (those not in sections)
  const customVariables = Object.keys(variables).filter(key => !sectionVariables.has(key));

  return (
    <div>
      <h2 className="text-lg font-medium mb-4">Variables</h2>
      
      <div className="space-y-4">
        {/* Section-based variables */}
        {CONTRACT_SECTIONS.map(section => {
          // Get variables used in this section
          const sectionVars = section.templateParts
            .filter(part => typeof part === 'object' && 'var' in part)
            .map(part => (part as { var: string }).var)
            .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates

          if (sectionVars.length === 0) return null;

          return (
            <div key={section.id} className="space-y-2">
              <h4 className="font-medium text-neutral-300 uppercase tracking-wide">{section.title}</h4>
              <div className="text-sm space-y-1">
                {sectionVars.map(key => (
                  <div key={key} className="flex items-center justify-between p-2 rounded bg-neutral-800/50">
                    <span className="text-indigo-300">{`{${key}}`}</span>
                    <span className="text-neutral-400 text-xs">{variables[key] || ''}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}

        {/* Custom variables */}
        {customVariables.length > 0 && (
          <div className="space-y-2">
            <h4 className="font-medium text-neutral-300 uppercase tracking-wide">Custom Variables</h4>
            <div className="text-sm space-y-1">
              {customVariables.map(key => (
                <div key={key} className="flex items-center justify-between p-2 rounded bg-neutral-800/50">
                  <span className="text-indigo-300">{`{${key}}`}</span>
                  <span className="text-neutral-400 text-xs">{variables[key]}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
